import type { FeatureConfig } from '@platform/client/features';

import './locales/i18n';

export default {
  routes: [
    {
      index: true,
      lazy: () => import('./dashboard/dashboard.page'),
    },
  ],
  navigation: () => ({}),
} satisfies FeatureConfig;
